import { createMuiTheme } from '@material-ui/core'

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    xs: false // removes the `xs` breakpoint
    sm: false
    md: false
    lg: false
    xl: false
    tablet: true // adds the `tablet` breakpoint
    laptop: true
    desktop: true
  }
}

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    customColors: {
      info: string
      action: string
      accent: string
      dark: string
      darkest: string
    }
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    customColors?: {
      info?: string
      action?: string
      accent?: string
      dark?: string
      darkest?: string
    }
    mobileSize: string
  }
}

const getTheme = (prefersDarkMode: boolean, mobileView: boolean) => {
  const muiTheme = createMuiTheme({
    typography: {
      fontSize: mobileView ? 9 : 12,
      fontFamily: 'Poppins, sans-serif',
    },
    palette: {
      type: prefersDarkMode ? 'light' : 'light',
      primary: { main: '#B4D337', light: '#F9F9F9' },
      secondary: { main: '#b6cf47' },
    },
    customColors: {
      info: '#b6cf47',
      action: '#f19e2c',
      accent: '#009fe3',
      dark: '#767576',
      darkest: 'black',
    },
    mobileSize: '767px',
    breakpoints: {
      values: {
        tablet: 767,
        laptop: 1024,
        desktop: 1280,
      },
    },
    overrides: {
      MuiTypography: {
        h1: {
          fontSize: mobileView ? '0.7rem' : '0.8rem',
        },
        h6: {
          fontSize: mobileView ? '0.7rem' : '0.8rem',
          fontStyle: 'italic',
        },
      },
      MuiTextField: {
        root: {
          padding: '0px',
        },
      },
      MuiInputLabel: {
        formControl: {
          position: 'relative',
        },
      },
      MuiInput: {
        formControl: {
          'label + &': {
            marginTop: '0.1rem',
          },
        },
      },
      MuiTabs: {
        root: {
          minHeight: '0px',
          textTransform: 'inherit',
        },
      },
      MuiTab: {
        root: {
          minHeight: '0px',
          textTransform: 'inherit',
          padding: '1px 10px',
        },
      },
    },
  })

  return muiTheme
}

export default getTheme
